import $ from "jquery";

const selectors = {
	iconCart: "[data-header-icon-cart]",
	iconCartCount: "[data-icon-cart-count]",
	countHeader: "[data-header-icon-cart-count]",
	cartNotification: "[data-cart-notification]"
};
$(async function () {
	if (!$(".cart-notification-product__item").length) {
		let cartContent = await getCart();
		$(selectors.cartNotification).replaceWith(cartContent);
	}
});

async function getCart() {
	let result = null;
	await $.ajax({
		url: "/cart?view=mini-cart",
		type: "get",
		dataType: "html",
		async: false,
		success: function (data) {
			result = data;
		},
		error: function () {
			$(selectors.iconCart).unbind("click").trigger("click");
		}
	});
	return result;
}

function closeSection() {
	const cart = $(selectors.cartNotification);
	cart.hasClass("active") ? cart.removeClass("active") : null;
}

async function addSection() {
	let cartContent = await getCart();
	$(selectors.cartNotification).replaceWith(cartContent);
	$(selectors.cartNotification).addClass("active");
	initCartEvents();
	const count = $(selectors.cartNotification).attr("data-count");
	if (+count > 0) {
		$(selectors.countHeader).html(count);
		$(selectors.countHeader).removeClass("hidden");
	} else {
		$(selectors.countHeader).addClass("hidden");
	}
}
function initCartEvents() {
	$(selectors.cartNotification).on("mouseleave", () => {
		if ($(selectors.cartNotification).hasClass("active")) {
			closeSection();
		}
	});
	$(document).on("click", ({ target }) => {
		const cart = $(selectors.cartNotification);
		if (target !== cart.get(0) && !cart.find(target).length) {
			if ($(selectors.cartNotification).hasClass("active")) {
				closeSection();
			}
		}
	});
}

$(document).on("openMiniCart", () => {
	if (window.screen.width >= 1200) {
		addSection();
	}
});

$(selectors.iconCart).on("click", (event) => {
	if (
		window.screen.width >= 1200 &&
		$("[data-header-wishlist]").css("display") !== "none"
	) {
		event.preventDefault();
	}
});
